var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.4148 4.5832C19.5815 3.59987 21.4648 3.59987 22.5982 4.5832L25.2315 6.8332C25.7315 7.24987 26.6815 7.59987 27.3482 7.59987H30.1815C31.9482 7.59987 33.3982 9.04987 33.3982 10.8165V13.6499C33.3982 14.3165 33.7482 15.2499 34.1648 15.7499L36.4148 18.3832C37.3982 19.5499 37.3982 21.4332 36.4148 22.5665L34.1648 25.1999C33.7482 25.6999 33.3982 26.6332 33.3982 27.2999V30.1332C33.3982 31.8999 31.9482 33.3499 30.1815 33.3499H27.3482C26.6815 33.3499 25.7482 33.6999 25.2482 34.1165L22.6148 36.3665C21.4482 37.3499 19.5648 37.3499 18.4315 36.3665L15.7982 34.1165C15.2982 33.6999 14.3482 33.3499 13.6982 33.3499H10.7815C9.01484 33.3499 7.56484 31.8999 7.56484 30.1332V27.2832C7.56484 26.6332 7.23151 25.6832 6.81484 25.1999L4.56484 22.5499C3.59818 21.3999 3.59818 19.5332 4.56484 18.3832L6.81484 15.7332C7.23151 15.2332 7.56484 14.2999 7.56484 13.6499V10.8332C7.56484 9.06654 9.01484 7.61654 10.7815 7.61654H13.6648C14.3315 7.61654 15.2648 7.26654 15.7648 6.84987L18.4148 4.5832Z",
    fill: "#FF3347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4987 28.6165C19.582 28.6165 18.832 27.8665 18.832 26.9499C18.832 26.0332 19.5654 25.2832 20.4987 25.2832C21.4154 25.2832 22.1654 26.0332 22.1654 26.9499C22.1654 27.8665 21.432 28.6165 20.4987 28.6165Z",
    fill: "#FF3347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.3665C19.8167 23.3665 19.25 22.7998 19.25 22.1165V14.0498C19.25 13.3665 19.8167 12.7998 20.5 12.7998C21.1833 12.7998 21.75 13.3665 21.75 14.0498V22.0998C21.75 22.7998 21.2 23.3665 20.5 23.3665Z",
    fill: "#FF3347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.ab6e41ccb501424bb563adc9ca55bdb9.svg";
export { ForwardRef as ReactComponent };